// extracted by mini-css-extract-plugin
export default {"container":"pageNotFound_container__c7L-K","icon":"pageNotFound_icon__eMkKH","title":"pageNotFound_title__gqXK4","homeBtn":"pageNotFound_homeBtn__4G7P2"};